module.exports = __webpack_public_path__ + "img/personas-mobile.41b4a14d.png";